import { render } from "./DeliveryNotification.vue?vue&type=template&id=52c29f28"
import script from "./DeliveryNotification.vue?vue&type=script&lang=js"
export * from "./DeliveryNotification.vue?vue&type=script&lang=js"
script.render = render

export default script